<template>
    <div class="block-editor send-sms">
        <div class="wrapper">
            <div class="title">SMS Provider</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.channelId" :defaultValue="null">
                    <a-select-option :selected="true" value="null">👉Select SMS Provider...</a-select-option>
                    <a-select-option :key="channel._id" v-for="channel of smsChannels" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Sender ID</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.senderId" :defaultValue="null">
                    <a-select-option
                        v-for="sender of senders"
                        :value="sender.title"
                        :key="sender.uuid"
                    >
                        {{ sender.title }}
                    </a-select-option>
                    <a-select-option :value="''">
                        📞Select Sender
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Phone Number</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="Phone Number"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.number"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Message</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="Mesajınızı Buraya Yazın."
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.message"
                    :max-character-count="160"
                />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";

const log = log2("SendSMS");
export default {
    name: "SendSMS",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            senders: [],
            credit: 0,
        };
    },
    computed: {
        ...mapState({
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            getPostacellChannelSenders: "channel/getPostacellChannelSenders",
        }),
        initPostacell() {
            this.getPostacellChannelSenders(this.clone.channelId).then((data) => {
                this.senders = _.get(data, "list", []);
            });
        },
    },
    mounted() {
        this.initPostacell();
        this.listChannels();
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.channelId": {
            handler(newValue) {
                this.initPostacell();
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-sms {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .ant-select {
            width: 100%;
        }
    }
}
</style>
